import { css, StyleSheet } from "aphrodite";

const HeaderStat = ({ value, label, statContainerStyles, valueStyles }) => {
  return (
    <div className={css(styles.headerStatContainer, statContainerStyles)}>
      <span className={css(styles.value, valueStyles)}>{value}</span>{" "}
      <span className={css(styles.label)}>{label}</span>
    </div>
  );
};

const styles = StyleSheet.create({
  headerStatContainer: {
    width: "100%",
    "@media only screen and (max-width: 1023px)": {
      alignItems: "center",
      textAlign: "center",
    },

    "@media only screen and (max-width: 767px)": {
      lineHeight: "27px",
    },
  },
  value: {
    fontSize: 20,
    fontWeight: 700,

    "@media only screen and (max-width: 767px)": {
      fontSize: 18,
    },
  },
  label: {
    fontSize: 14,
    fontWeight: 400,
    opacity: 0.8,
  },
});
export default HeaderStat;
